import type { IconProps } from "./types";

export function Filter({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.8998 3C21.2512 3 21.5702 3.20521 21.7171 3.52441C21.8639 3.8435 21.8117 4.2185 21.5834 4.48535L14.6 12.6406V20.9004C14.6 21.2115 14.4393 21.5008 14.1752 21.665C13.9109 21.8293 13.5801 21.8448 13.3011 21.707L9.70152 19.9297C9.39455 19.7781 9.19973 19.4654 9.19957 19.123V12.6406L2.21617 4.48535C1.98782 4.2185 1.93561 3.8435 2.08238 3.52441C2.22929 3.20521 2.54837 3 2.89976 3H20.8998ZM10.7836 11.7236C10.9232 11.8867 10.9994 12.0949 10.9994 12.3096V18.5625L12.8002 19.4521V12.3096C12.8002 12.0949 12.8763 11.8867 13.016 11.7236L18.9447 4.80078H4.85484L10.7836 11.7236Z"
        fill={currentColor}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
